export default __webpack_public_path__ + "media/images/brands/expmessenger/logos/logo-light-165x76-0774829163f398af4269b790372f8f7e.png";